module.exports = __webpack_public_path__ + "img/floor_f15_01.8d98ef18.png";